import axios from "axios";
import {
  GET_SUBSCRIPTIONS,
  REMOVE_SUBSCRIPTION,
  SIGNED_REMOVE_SUBSCRIPTION,
  CREATE_SUBSCRIPTIONS,
  VERIFY_SUBSCRIPTION,
  SIGNED_VERIFY_SUBSCRIPTION,
  RESET_SUBSCRIPTION,
  GET_CONTACT_SUBSCRIPTIONS,
} from "../actions/subscriptions";
import { APP_ERROR, HIDE_LOADER, SHOW_LOADER } from "../actions/common";
import { CONFIG } from "../../config";

const state = {
  subscriptions: [],
};

const getters = {
  subscriptions: state => state.subscriptions,
};

const actions = {
  [VERIFY_SUBSCRIPTION]: ({ commit, dispatch }, { subscription, verificationCode }) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      let token = sessionStorage.getItem("jwttoken") || "";
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription/verify",
        data: {
          SubscriptionId: subscription.id,
          Client: subscription.client,
          ContactType: subscription.contactType,
          VerificationCode: verificationCode,
        },
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(VERIFY_SUBSCRIPTION);
            resolve(resp.data);
          } else {
            resolve(false);
          }
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [SIGNED_VERIFY_SUBSCRIPTION]: ({ commit, dispatch }, verificationToken) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription/signedverify",
        data: { signedToken: verificationToken },
        method: "POST",
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(SIGNED_VERIFY_SUBSCRIPTION);
            resolve(resp.data);
          } else {
            resolve(false);
          }
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [RESET_SUBSCRIPTION]: ({ commit, dispatch }, subscription) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      let token = sessionStorage.getItem("jwttoken") || "";
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription/reset",
        data: {
          SubscriptionId: subscription.id,
        },
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(RESET_SUBSCRIPTION);
          }
          resolve();
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [REMOVE_SUBSCRIPTION]: ({ commit, dispatch }, subscription) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      let token = sessionStorage.getItem("jwttoken") || "";
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription",
        data: {
          SubscriptionId: subscription.id,
        },
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(REMOVE_SUBSCRIPTION);
          }
          resolve();
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [SIGNED_REMOVE_SUBSCRIPTION]: ({ commit, dispatch }, removeTokens) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      const tokens = Array.isArray(removeTokens) ? removeTokens : [removeTokens];
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription/signedunsubscribe",
        data: tokens.map(token => ({ signedToken: token })),
        method: "DELETE",
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(SIGNED_REMOVE_SUBSCRIPTION);
          }
          resolve();
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [GET_SUBSCRIPTIONS]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      let token = sessionStorage.getItem("jwttoken") || "";
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription",
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(GET_SUBSCRIPTIONS, resp.data);
          }
          resolve();
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [CREATE_SUBSCRIPTIONS]: ({ commit, dispatch }, subscriptions) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      let token = sessionStorage.getItem("jwttoken") || "";
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription/create",
        data: subscriptions,
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(resp => {
          if (resp.status === 200) {
            commit(CREATE_SUBSCRIPTIONS);
            resolve(resp.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
  [GET_CONTACT_SUBSCRIPTIONS]: ({ commit, dispatch }, token) => {
    return new Promise((resolve, reject) => {
      commit(SHOW_LOADER);
      axios({
        url: CONFIG.BACKEND_URL + "api/subscription/contact",
        method: "GET",
        params: { id: token },
      })
        .then(resp => {
          if (resp.status === 200) {
            resolve(resp.data);
          } else {
            resolve([]);
          }
        })
        .catch(err => {
          dispatch(APP_ERROR, err);
          reject(err);
        })
        .finally(() => {
          commit(HIDE_LOADER);
        });
    });
  },
};

const mutations = {
  [GET_SUBSCRIPTIONS]: (state, subscriptions) => {
    state.subscriptions = subscriptions;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
